import React from "react";
import { MobileCardItem, LinkAnimation } from "../../../../";
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
import AddLocationIcon from "@material-ui/icons/AddLocation";
var useStyles = makeStyles(function (theme) {
  return {
    my12: {
      margin: "12px 0"
    },
    m12: {
      margin: "12px"
    },
    mt8: {
      marginTop: "8px"
    },
    icon: {
      marginRight: "16px"
    },
    breadcrumb: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      justifyContent: "flex-end",
      height: "60px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    content: {
      paddingTop: "72px",
      width: "100%"
    }
  };
});

var MobileCampusProfileTabShifts = function MobileCampusProfileTabShifts(props) {
  // console.log("MobileCampusProfileTabShifts props", props);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.breadcrumb
  }, /*#__PURE__*/React.createElement(LinkAnimation, {
    to: "/app/shift",
    action: "checkin",
    direction: "left"
  }, /*#__PURE__*/React.createElement(AddLocationIcon, {
    fontSize: "large",
    className: classes.icon,
    color: "primary"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.textFlexWidth
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.textAnimation7s
  }, props.userName || ""))), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, props.data ? props.data.map(function (shift) {
    return /*#__PURE__*/React.createElement(MobileCardItem, {
      template: "profileShiftListStaff",
      data: shift,
      classes: classes.m12
    });
  }) : null));
};

export { MobileCampusProfileTabShifts };